export function formatCurrency(value, currency = "") {
    const formatted = Number(value).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    return currency ? `${formatted} ${currency}` : formatted;
}
